import { useEffect } from "react";

/**
 * Custom hook to set the page title
 * @param title - The page title (will be prefixed with "Swarapoint Web - ")
 */
export const usePageTitle = (title: string): void => {
  useEffect(() => {
    document.title = `Swarapoint - ${title}`;
    
    // Cleanup: reset to default title when component unmounts
    return () => {
      document.title = "Swarapoint Web";
    };
  }, [title]);
};
